"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldDate = exports.sameOutputDate = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const dateTime_1 = require("../../../../utils/dateTime");
const dateTimeFormat_1 = require("../../../../utils/dateTimeFormat");
const locale_1 = require("../../../../utils/locale");
const mobilePlatform_1 = require("../../../../utils/mobilePlatform");
const DayPicker_1 = require("../../../Date/DayPicker");
const DayPickerFooter_1 = require("../../../Date/DayPickerFooter");
const DayPickerWrapper_1 = require("../../../Date/DayPickerWrapper");
const YearMonthForm_1 = require("../../../Date/YearMonthForm");
const Field_1 = require("../../Field");
const Time_1 = require("../Time");
const useLazyValue_1 = require("./useLazyValue");
require("react-day-picker/lib/style.css");
require("./index.scss");
const useOutDateClick_1 = require("./useOutDateClick");
const className = 'form-field-date';
/** Empty date is really empty. Skip null !== undefined !== ''. It does not matter */
const castEmpty = (x) => [null, undefined, ''].includes(x) ? '' : x;
const sameOutputDate = (x, y) => castEmpty(x) === castEmpty(y);
exports.sameOutputDate = sameOutputDate;
/** @deprecated Use FormFieldDateStable. ToDo: Implement FormFieldDateTime for withTime case */
const FormFieldDate = (props) => {
    var _a, _b, _c;
    const { withTime, label, restrictions, showUpper, error, modificators, modifiers, modifiersStyles, value = '', setValue = () => { }, onBlur = () => { }, ...restProps } = props;
    const intl = (0, react_intl_1.useIntl)();
    const [lazyValue, onLazyChange] = (0, useLazyValue_1.useLazyValue)(value, setValue, exports.sameOutputDate);
    const [viewDate, setViewDate] = (0, react_1.useState)((_b = (_a = (0, dateTime_1.parseOutputDateTime)(lazyValue)) === null || _a === void 0 ? void 0 : _a.toDate()) !== null && _b !== void 0 ? _b : (0, dateTime_1.todayZeroTime)());
    const [dateTimeText, setDateTimeText] = (0, react_1.useState)((0, dateTime_1.mapToInputDateTime)(props.value));
    (0, react_1.useEffect)(() => {
        var _a, _b;
        setViewDate((_b = (_a = (0, dateTime_1.parseOutputDateTime)(lazyValue)) === null || _a === void 0 ? void 0 : _a.toDate()) !== null && _b !== void 0 ? _b : (0, dateTime_1.todayZeroTime)());
        setDateTimeText((0, dateTime_1.mapToInputDateTime)(lazyValue));
    }, [lazyValue]);
    const [isOpenPicker, setIsOpenPicker] = (0, react_1.useState)(false);
    const [errors, setErrors] = (0, react_1.useState)({});
    (0, react_1.useEffect)(() => {
        const newErrors = (0, dateTime_1.validateDateTime)(dateTimeText, restrictions, withTime, true);
        setErrors(newErrors);
    }, [dateTimeText, withTime, restrictions]);
    const selectedDate = (0, react_1.useMemo)(() => { var _a, _b; return (_b = (0, dateTime_1.parseInputDate)((_a = dateTimeText.date) !== null && _a !== void 0 ? _a : '')) === null || _b === void 0 ? void 0 : _b.toDate(); }, [dateTimeText]);
    const sameDateTime = (dateTime) => (dateTime.date === dateTimeText.date && dateTime.time === dateTimeText.time);
    const updateViewDate = (dateTime, isBlur) => {
        var _a, _b, _c;
        if (sameDateTime(dateTime))
            return;
        if (!withTime)
            dateTime.time = Time_1.TIME_INITIAL;
        if (isBlur && !dateTime.date && !dateTime.time) {
            setViewDate((0, dateTime_1.todayZeroTime)());
            return;
        }
        const date = (_b = (_a = (0, dateTime_1.parseInputDate)(dateTime.date)) === null || _a === void 0 ? void 0 : _a.toDate()) !== null && _b !== void 0 ? _b : viewDate;
        const time = (_c = (0, dateTime_1.parseInputTime)(dateTime.time)) !== null && _c !== void 0 ? _c : {
            hours: viewDate.getHours(),
            minutes: viewDate.getMinutes(),
        };
        date.setHours(time.hours);
        date.setMinutes(time.minutes);
        setViewDate(date);
    };
    const updateState = (dateTime, isBlur) => {
        var _a, _b;
        if (!withTime)
            dateTime.time = Time_1.TIME_INITIAL;
        const outputFormat = withTime ? dateTimeFormat_1.DATETIME_OUTPUT_FORMAT : dateTimeFormat_1.DATE_OUTPUT_FORMAT;
        const outputDateTime = (_b = (_a = (0, dateTime_1.parseInputDateTime)(dateTime)) === null || _a === void 0 ? void 0 : _a.format(outputFormat)) !== null && _b !== void 0 ? _b : '';
        onLazyChange(outputDateTime);
        if (isBlur) {
            setIsOpenPicker(false);
            onBlur(outputDateTime);
        }
        const newDateTime = isBlur ? (0, dateTime_1.standardizeInputDateTime)(dateTime) : dateTime;
        if (!sameDateTime(newDateTime)) {
            updateViewDate(newDateTime, isBlur);
            setDateTimeText(newDateTime);
        }
    };
    const { rootRef } = (0, useOutDateClick_1.useOutDateClick)(() => {
        updateState(dateTimeText, true);
    });
    const isMobile = (0, mobilePlatform_1.checkMobilePlatform)();
    const disabledDays = (0, dateTime_1.getDisabledDays)(restrictions);
    const dayPickerProps = {
        captionElement: ({ localeUtils }) => {
            const yearMonthFormProps = {
                date: viewDate,
                localeUtils,
                onChange: (newDate) => {
                    const date = (0, moment_1.default)(newDate).format(dateTimeFormat_1.DATE_FORMAT);
                    updateViewDate({ date, time: dateTimeText.time }, false);
                },
                restrictions,
            };
            return (react_1.default.createElement(YearMonthForm_1.YearMonthForm, { ...yearMonthFormProps }));
        },
        numberOfMonths: 1,
        selectedDays: selectedDate,
        disabledDays,
        onDayClick: (newDate, dayModifiers) => {
            if (props.readOnly || dayModifiers.disabled)
                return;
            const date = (0, moment_1.default)(newDate).format(dateTimeFormat_1.DATE_FORMAT);
            updateState({ date, time: dateTimeText.time }, !withTime);
        },
        month: viewDate,
        firstDayOfWeek: 1,
        onMonthChange: (newDate) => {
            const date = (0, moment_1.default)(newDate).format(dateTimeFormat_1.DATE_FORMAT);
            updateViewDate({ date, time: dateTimeText.time }, false);
        },
        locale: (0, locale_1.mapLocaleToLocaleCode)(intl.locale),
        modifiers,
        modifiersStyles,
    };
    const timePickerProps = {
        value: (0, moment_1.default)(viewDate).format(dateTimeFormat_1.TIME_FORMAT),
        onChange: (data) => {
            if (props.readOnly)
                return;
            const time = data || '';
            updateState({ date: dateTimeText.date, time }, false);
        },
    };
    const dayPickerFooterProps = {
        resetHidden: !(dateTimeText.date || (withTime && dateTimeText.time)),
        onClose: () => {
            updateState(dateTimeText, true);
        },
        onResetClick: () => {
            updateState({}, true);
        },
    };
    const pickerElement = isOpenPicker && (react_1.default.createElement(DayPickerWrapper_1.DayPickerWrapper, null,
        react_1.default.createElement("div", { className: `${className}__picker-body` },
            react_1.default.createElement(DayPicker_1.DayPicker, { ...dayPickerProps }),
            withTime && (react_1.default.createElement("div", { className: `${className}__picker-time` },
                react_1.default.createElement("div", { className: `${className}__picker-time-caption` },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Form/Field/Date:Time', defaultMessage: 'Time' })),
                react_1.default.createElement("div", { className: `${className}__picker-time-input` },
                    react_1.default.createElement(Time_1.FormFieldTime, { ...timePickerProps }))))),
        react_1.default.createElement("div", { className: `${className}__picker-footer` },
            react_1.default.createElement(DayPickerFooter_1.DayPickerFooter, { ...dayPickerFooterProps }))));
    const dateFieldProps = {
        ...restProps,
        error: [errors.date, error],
        modificators,
        label,
        onChange: (event) => {
            setIsOpenPicker(true);
            const date = event.target.value;
            updateState({ date, time: dateTimeText.time }, false);
        },
        onFocus: () => {
            setIsOpenPicker(true);
        },
        value: (_c = dateTimeText.date) !== null && _c !== void 0 ? _c : '',
        placeholder: (0, moment_1.default)().format(dateTimeFormat_1.DATE_FORMAT),
        inputMode: isMobile ? 'none' : 'text',
        addonIcon: 'calendar',
    };
    const timeFieldProps = {
        ...restProps,
        error: errors.time,
        label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Form/Field/Date:Time', defaultMessage: 'Time' })),
        onChange: (event) => {
            setIsOpenPicker(true);
            const time = event.target.value;
            updateState({ date: dateTimeText.date, time }, false);
        },
        onFocus: () => {
            setIsOpenPicker(true);
        },
        value: dateTimeText.time,
        placeholder: (0, moment_1.default)().format(dateTimeFormat_1.TIME_FORMAT),
        inputMode: isMobile ? 'none' : 'text',
        hidden: !withTime,
    };
    const inputElement = (react_1.default.createElement("div", { className: 'form-fields-together' },
        react_1.default.createElement(Field_1.FormField, { ...dateFieldProps }),
        react_1.default.createElement(Field_1.FormField, { ...timeFieldProps })));
    return (react_1.default.createElement("div", { className: className, ref: rootRef },
        showUpper && pickerElement,
        inputElement,
        !showUpper && pickerElement));
};
exports.FormFieldDate = FormFieldDate;
//# sourceMappingURL=index.js.map